<template>
  <div>
    <link href="../../static/distribution-musical/css/plugins.css" rel="stylesheet" type="text/css" media="all">
    <link href="../../static/distribution-musical/css/theme.css" rel="stylesheet" type="text/css" media="all">
    <link href="../../static/distribution-musical/css/custom.css" rel="stylesheet" type="text/css" media="all">
    <link href='https://fonts.googleapis.com/css?family=Open+Sans:400,300%7CMontserrat:400,700%7CRaleway:400,200,300' rel='stylesheet' type='text/css'>
    <!-- Hero Slider -->
    <section class="hero-fullscreen" style="height:100vh;">
      <div class="hero-slider hero-parallax-fullscreen owl-carousel navigation-thin">
        <!-- Slide 1 -->
        <div class="slide bg-attraction-proweekend">
          <div class="hero-container container">
            <div class="hero-content scroll-opacity">
              <div class="appear container text-center">
                <a class="logo-dark" href="/">
                  <img src="https://indiefy.net/static/img/logo_white_new.png" alt="logo-indiefy" style="max-width:230px">
                </a>
                <p class="subheading white mt40" v-if="lang === 'es'">Distribucion musical para todos</p>
                <p class="subheading white mt40" v-else>MUSIC DISTRIBUTION FOR EVERYONE</p>
                <h1 class="lg-heading white mb40">Pro Weekend</h1>
                <p class="attrac-description yellow animated fadeInDown" v-if="nowServer.isAfter(dateEnd)">
                  <span v-if="lang === 'es'">Muy pronto</span>
                  <span v-else>Coming soon</span>
                </p>
                <p class="attrac-description yellow animated fadeInDown" v-else-if="nowServer.isBetween(dateStart, dateEnd)">
                  <span v-if="lang === 'es'">Tiempo restante</span>
                  <span v-else>Time remaining</span>
                </p>
                <p class="attrac-description yellow animated fadeInDown" v-else>
                  <span>{{ titleProWeek }}</span>
                </p>
                <section class="container-countdown">
                  <ul v-show="showCount">
                    <li class="animated fadeInUp">
                      <span class="days time-numbers">{{ dayTime }}</span>
                      <p class="timeRefDays timedescription" v-if="lang === 'es'">d&iacute;as</p>
                      <p class="timeRefDays timedescription" v-else>days</p>
                    </li>
                    <li class="animated fadeInUp">
                      <span class="hours time-numbers">{{ hourTime }}</span>
                      <p class="timeRefHours timedescription" v-if="lang === 'es'">horas</p>
                      <p class="timeRefHours timedescription" v-else>hours</p>
                    </li>
                    <li class="animated fadeInUp">
                      <span class="minutes time-numbers">{{ minutesTime }}</span>
                      <p class="timeRefMinutes timedescription" v-if="lang === 'es'">minutos</p>
                      <p class="timeRefMinutes timedescription" v-else>minutes</p>
                    </li>
                    <li class="animated fadeInUp">
                      <span class="seconds time-numbers yellow-text">{{ secondsTime }}</span>
                      <p class="timeRefSeconds timedescription" v-if="lang === 'es'">segundos</p>
                      <p class="timeRefSeconds timedescription" v-else>seconds</p>
                    </li>
                  </ul>
                </section>
                <a href="login" class="btn btn-ghost-pink btn-scroll mt60 btn-more" v-if="lang === 'es'">Activar ahora</a>
                <a href="login" class="btn btn-ghost-pink btn-scroll mt60 btn-more" v-else>Activate now</a>
              </div>
            </div>
          </div>
        </div>
        <!-- End Slide 1 -->
      </div>
    </section>
    <!-- End Hero Slider -->
    <div class="site-wrapper">
      <!-- Start Features -->
      <section id="proweekendFeatures">
        <div class="container">
          <div class="row">
            <div class="col-md-12 text-center section-heading mb20" v-if="lang === 'es'">
              <h5 class="yellow"><b>Preguntas Frecuentes</b></h5>
              <h3 class="white">¿C&oacute;mo funciona PRO WEEKEND?</h3>
              <p class="white">PRO WEEKEND es un evento temporal del cu&aacute;l podr&aacute;s conocer de los <br> beneficios
                que tiene la membres&iacute;a PRO.</p>
            </div>
            <div class="col-md-12 text-center section-heading mb20" v-else>
              <h5 class="yellow"><b>FREQUENTLY ASKED QUESTIONS</b></h5>
              <h3 class="white">How does PRO WEEKEND work?</h3>
              <p class="white">PRO WEEKEND is a limited event from which you can learn about the benefits of the <br> PRO membership.</p>
            </div>
            <div class="col-md-4 col-sm-6 mt30 mb30" v-if="lang === 'es'">
              <div class="feature-icon faqs-number">
                <span class="yellow">1</span>
              </div>
              <div class="feature-info">
                <h4 class="white">Reg&iacute;strate en la plataforma</h4>
                <p class="white">Elige tu forma de acceso ya sea con redes sociales o con tu correo electr&oacute;nico.</p>
              </div>
            </div>
            <div class="col-md-4 col-sm-6 mt30 mb30" v-else>
              <div class="feature-icon faqs-number">
                <span class="yellow">1</span>
              </div>
              <div class="feature-info">
                <h4 class="white">Register and login</h4>
                <p class="white">Choose your form of access either with social networks or with your email.</p>
              </div>
            </div>
            <div class="col-md-4 col-sm-6 mt30 mb30" v-if="lang === 'es'">
              <div class="feature-icon faqs-number">
                <span class="yellow">2</span>
              </div>
              <div class="feature-info">
                <h4 class="white">Activa PRO WEEKEND</h4>
                <p class="white">Una vez registrado activa tu Pro Weekend pass para comenzar a usarlo.
                </p>
              </div>
            </div>
            <div class="col-md-4 col-sm-6 mt30 mb30" v-else>
              <div class="feature-icon faqs-number">
                <span class="yellow">2</span>
              </div>
              <div class="feature-info">
                <h4 class="white">Activate PRO WEEKEND Pass</h4>
                <p class="white">Once registered, activate your Pro Weekend pass to start using it.</p>
              </div>
            </div>
            <div class="col-md-4 col-sm-6 mt30 mb30" v-if="lang === 'es'">
              <div class="feature-icon faqs-number">
                <span class="yellow">3</span>
              </div>
              <div class="feature-info">
                <h4 class="white">Disfruta por 48 horas *</h4>
                <p class="white">Tendr&aacute;s 48 horas para distribuir t&uacute; m&uacute;sica a TODAS
                  las tiendas y hacer uso de la mayor&iacute;a de los beneficios de la membres&iacute;a PRO.</p>
              </div>
            </div>
            <div class="col-md-4 col-sm-6 mt30 mb30" v-else>
              <div class="feature-icon faqs-number">
                <span class="yellow">3</span>
              </div>
              <div class="feature-info">
                <h4 class="white">Enjoy for 48 Hours *</h4>
                <p class="white">You will have 48 hours to distribute your music to all stores and make use of most of the
                  benefits of the PRO membership.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- End Features -->
      <!-- Start Banner stores -->
      <section class="pt10 bg-stores stores-container">
        <div class="container">
          <div class="counter-row row text-center">
            <div class="col-md-12 fact-container ">
              <span class="text-uppercase text-30 white" v-if="lang === 'es'">Lanza tu m&uacute;sica en +32 tiendas</span>
              <span class="text-uppercase text-30 white" v-else>Deliver to all 32+ stores</span>
            </div>
          </div>
        </div>
      </section>
      <!-- End Banner stores -->
      <!-- Start Benefits -->
      <section class="pt130 pb100 benefits">
        <div class="container">
          <div class="row">
            <div class="col-md-12 text-center section-heading mb50" v-if="lang === 'es'">
              <h5><b>BENEFICIOS PRO</b></h5>
              <h3>¿Qu&eacute; obtendr&eacute;?</h3>
            </div>
            <div class="col-md-12 text-center section-heading mb50" v-else>
              <h5><b>PRO BENEFITS</b></h5>
              <h3>What will I get?</h3>
            </div>
            <div class="col-md-4 col-sm-6 text-center benefit">
              <div class="pt30 pb30 mb30 elem">
                <div class="container-img">
                  <img src="../../static/pro-weekend/benefits-1.png" alt="">
                </div>
                <div class="bold-800 mt-2 text-18 title" v-if="lang === 'es'">Distribuci&oacute;n a todas las tiendas</div>
                <div class="bold-800 mt-2 text-18 title" v-else>Delivery to all stores</div>
              </div>
            </div>
            <div class="col-md-4 col-sm-6 text-center benefit">
              <div class="pt30 pb30 mb30 elem">
                <div class="container-img">
                  <img src="../../static/pro-weekend/benefits-2.png" alt="">
                </div>
                <div class="bold-800 mt-2 text-18 title" v-if="lang === 'es'">Distribuci&oacute;n a Youtube Content ID</div>
                <div class="bold-800 mt-2 text-18 title" v-else>Delivery to YouTube Content ID</div>
              </div>
            </div>
            <div class="col-md-4 col-sm-6 text-center benefit">
              <div class="pt30 pb30 mb30 elem">
                <div class="container-img">
                  <img src="../../static/pro-weekend/benefits-3.png" alt="" class="mt-4">
                </div>
                <div class="bold-800 mt-2 text-18 title" v-if="lang === 'es'">Lanzamientos ilimitados</div>
                <div class="bold-800 mt-2 text-18 title" v-else>Unlimited Releases</div>
              </div>
            </div>
            <div class="col-md-4 col-sm-6 text-center benefit">
              <div class="pt30 pb30 mb30 elem">
                <div class="container-img">
                  <img src="../../static/pro-weekend/benefits-4.png" alt="">
                </div>
                <div class="bold-800 mt-2 text-18 title" v-if="lang === 'es'">Lanzamientos en 10 d&iacute;as</div>
                <div class="bold-800 mt-2 text-18 title" v-else>Deliver in 10 days</div>
              </div>
            </div>
            <div class="col-md-4 col-sm-6 text-center benefit">
              <div class="pt30 pb30 mb30 elem">
                <div class="container-img">
                  <img src="../../static/pro-weekend/benefits-5.png" alt="">
                </div>
                <div class="bold-800 mt-2 text-18 title" v-if="lang === 'es'">Crea hasta 3 artistas</div>
                <div class="bold-800 mt-2 text-18 title" v-else>Create up to 3 artists</div>
              </div>
            </div>
            <div class="col-md-4 col-sm-6 text-center benefit">
              <div class="pt30 pb30 mb30 elem">
                <div class="container-img">
                  <img src="../../static/pro-weekend/benefits-6.png" alt="">
                </div>
                <div class="bold-800 mt-2 text-18 title" v-if="lang === 'es'">Pre-order en Amazon</div>
                <div class="bold-800 mt-2 text-18 title" v-else>Pre-order on Amazon</div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- End Benefits -->
      <!-- Start Footer 1 -->
      <footer id="footer-1" class="pt60 pb50 bg-footer">
        <div class="container">
          <div class="row">
            <div class="col-md-12 text-center section-heading" v-if="lang === 'es'">
              <h5 class="yellow">¿LISTO PARA COMENZAR?</h5>
              <h1 class="white">¡No te lo pierdas!</h1>
            </div>
            <div class="col-md-12 text-center section-heading" v-else>
              <h5 class="yellow">READY TO START?</h5>
              <h1 class="white">Don’t miss it!</h1>
            </div>
            <div class="col-md-12 text-center mb120">
              <a href="/login" class="btn btn-ghost-pink btn-scroll mt60 btn-more" v-if="lang === 'es'">Activar ahora</a>
              <a href="/login" class="btn btn-ghost-pink btn-scroll mt60 btn-more" v-else>Activate Now</a>
            </div>
            <div class="col-md-4 mb120 d-none d-sm-block">&nbsp;</div>
            <div class="col-md-4 text-center">
              <h4>About Indiefy</h4>
              <p class="footer-description">
                Indiefy is an American registered Company since 2017.<br>
                <a href="/" target="_blank">
                  © Indiefy {{ year }}
                </a>
                -
                <a href="/terms#proweekend-terms-use" target="_blank">
                  {{ $t('terms_and_conditions') }}
                </a>
                <br>
                <span class="white bold-200 text-12" v-if="lang === 'es'">
                  * Retiros no incluidos
                </span>
                <span class="white bold-200 text-12" v-else>
                  * Withdrawals not included
                </span>
              </p>
            </div>
            <div class="col-md-4 d-none d-sm-block">&nbsp;</div>
          </div>
        </div>
      </footer>
      <!-- End Footer 1 -->
    </div>
  </div>
</template>
<style scoped lang="scss">
  * {
    font-family: Poppins, sans-serif !important;
  }
  .attrac-description {
    font-size: 4rem;
    margin: 0 auto;
    padding: 0;
    letter-spacing: 0.5rem;
    text-transform: uppercase;

    &:last-child {
      font-size: 2rem;
      font-weight: 700;
      margin: 3em auto;
      padding: 0;
      letter-spacing: 0.1rem;

      >a {
        text-decoration: none;
        color: inherit;
        -moz-transition: all 0.2s ease-in;
        -o-transition: all 0.2s ease-in;
        -webkit-transition: all 0.2s ease-in;
        transition: all 0.2s ease-in;

        &:hover {
          color: #fff;
        }
      }
    }
  }
  .container-countdown {
    color: #fff;
    margin: 0 auto;
    line-height: 24px;
    font-size: 20rem;
    font-weight: 700;

    ul {
      list-style-type: none;
      margin-bottom: 0;
      margin-left: 0;

      li {
        color: #fff;
        display: inline-block;
        margin-right: 2rem;
        width: 6rem;
      }
    }

    .time-numbers {
      display: block;
      font-size: 3.5rem;
      font-weight: 400;
      line-height: 3.5rem;
      margin: 0 auto;
      text-align: center;
    }

    p.timedescription {
      font-size: 1.9rem;
      font-variant: small-caps;
      line-height: 1.9rem;
      margin: 0 auto;
      text-align: center;
      position: relative;
      top: 0px;
      color:#FFE100;
      word-break: initial;
    }
  }
  .stores-container {
    letter-spacing: 9px;
  }
  .benefits {
    background: #f5f5fd;
    .benefit {
      .elem {
        background: #fff;
        border-radius: 12px;
        .container-img {
          min-height: 100px;
          img {
            max-width: 70px;
          }
        }
      }
    }
  }
  @media only screen and (max-width: 1366px)  {
    .bg-footer {
      background-position: center;
    }
  }
  @media only screen and (max-width: 768px)  {
    .benefits {
      .benefit {
        .elem {
          padding: 30px;
          .container-img {
            img {
              max-width: 58px;
            }
          }
          .title {
            font-size: 14px;
          }
        }
      }
    }
  }
  @media screen and (max-width: 578px) {
    #proweekendFeatures {
      padding-top: 60px;
      padding-bottom: 40px;
    }
    .attrac-description {
      font-size: 2rem;
    }
    .container-countdown {
      ul {
        li {
          margin-right: 0rem;
          width: 2rem;
        }
      }
      .time-numbers {
        font-size: 2.5rem;
        line-height: 2.5rem;
      }
      p.timedescription {
        font-size: 1.3rem;
        line-height: 1.3rem;
      }
    }
    .benefits {
      padding-top: 60px!important;
      padding-bottom: 40px!important;
    }
    .bg-footer {
      padding-top: 10px!important;
      padding-bottom: 0px!important;
    }
  }
  @media screen and (max-width: 360px) {
    .owl-item.active .appear {
      margin-top: 60px !important;
    }
  }
  @media screen and (max-width: 320px) {
    .hero-fullscreen {
      position: initial;
    }
    .lg-heading {
      margin-bottom: 10px !important;
    }
    .subheading {
      margin-top: 10px !important;
    }
    .container-countdown {
      line-height: 0px;
      font-size: 3rem;
      ul {
        li {
          width: 5rem;
        }
      }
      .time-numbers {
        font-size: 2.5rem;
        line-height: 2.5rem;
      }
      p.timedescription {
        font-size: 1.3rem;
        line-height: 1.3rem;
      }
    }
    .btn-more {
      margin-top: 30px !important;
      padding: 12px 20px 10px 20px;
      font-size: 12px;
    }
    .owl-item.active .appear {
      margin-top: -70px !important;
    }
  }
</style>
<script>
import Configuration from '../services/configuration'
import moment from 'moment'
export default {
  name: 'ProLayout',
  lang: 'en',
  data () {
    return {
      year: new Date().getFullYear(),
      dayTime: '00',
      hourTime: '00',
      minutesTime: '00',
      secondsTime: '00',
      showCount: false,
      moment: moment,
      nowServer: moment().utc(),
      dateStart: moment().utc(),
      dateEnd: moment().utc(),
      titleProWeek: ''
    }
  },
  methods: {

  },
  created: function () {
    if (this.$i18n) {
      this.lang = this.$i18n.locale
    }
    if (this.$route.query.lang) {
      this.lang = this.$route.query.lang
    }
    let promiseConfig = new Promise((resolve, reject) => {
      Configuration.get({fields: ['pro_weekend_title_date', 'pro_weekend_active', 'pro_weekend_date_end', 'pro_weekend_date_start']}).then(response => {
        if (response.data.pro_weekend_active) { // temporizador
          resolve(response.data)
        } else {
          resolve(false)
        }
      }).catch(err => {
        reject(new Error(err))
      })
    })
    let promiseNow = new Promise((resolve, reject) => {
      Configuration.now().then(response => {
        if (response.data) { // temporizador
          resolve(response.data)
        } else {
          resolve(false)
        }
      }).catch(err => {
        reject(new Error(err))
      })
    })
    Promise.all([promiseConfig, promiseNow])
      .then(resolveArr => {
        if (!resolveArr[0] || !resolveArr[1]) {
          return false
        }
        this.nowServer = moment(resolveArr[1].now_iso)
        this.dateStart = moment(resolveArr[0].pro_weekend_date_start)
        this.dateEnd = moment(resolveArr[0].pro_weekend_date_end)
        this.titleProWeek = resolveArr[0].pro_weekend_title_date
        console.log('nowServer', this.nowServer.format('LLL'))
        console.log('dateStart', this.dateStart.format('LLL'))
        console.log('dateEnd', this.dateEnd.format('LLL'))
        if (this.nowServer.isAfter(this.dateEnd)) {
          console.log('ya paso la fecha')
        } else if (this.nowServer.isBetween(this.dateStart, this.dateEnd)) {
          console.log('evento activo')
          let currentTime = moment(this.nowServer).unix()
          let eventTime = moment(this.dateEnd).unix()
          let leftTime = eventTime - currentTime
          let duration = moment.duration(leftTime, 'seconds')
          let interval = 1000
          let intervalId = setInterval(() => {
            // Time Out check
            if (duration.asSeconds() <= 0) {
              clearInterval(intervalId)
              location.reload()
            } else {
              if (!this.showCount) {
                this.showCount = true
              }
              duration = moment.duration(duration.asSeconds() - 1, 'seconds')
              this.dayTime = String(duration.days()).length === 1 ? '0' + duration.days() : duration.days()
              this.hourTime = String(duration.hours()).length === 1 ? '0' + duration.hours() : duration.hours()
              this.minutesTime = String(duration.minutes()).length === 1 ? '0' + duration.minutes() : duration.minutes()
              this.secondsTime = String(duration.seconds()).length === 1 ? '0' + duration.seconds() : duration.seconds()
            }
          }, interval)
        } else {
          console.log('antes del evento')
          let currentTime = moment(this.nowServer).unix()
          let eventTime = moment(this.dateStart).unix()
          let leftTime = eventTime - currentTime
          let duration = moment.duration(leftTime, 'seconds')
          let interval = 1000
          let intervalId = setInterval(() => {
            // Time Out check
            if (duration.asSeconds() <= 0) {
              clearInterval(intervalId)
              location.reload()
            } else {
              if (!this.showCount) {
                this.showCount = true
              }
              duration = moment.duration(duration.asSeconds() - 1, 'seconds')
              this.dayTime = String(duration.days()).length === 1 ? '0' + duration.days() : duration.days()
              this.hourTime = String(duration.hours()).length === 1 ? '0' + duration.hours() : duration.hours()
              this.minutesTime = String(duration.minutes()).length === 1 ? '0' + duration.minutes() : duration.minutes()
              this.secondsTime = String(duration.seconds()).length === 1 ? '0' + duration.seconds() : duration.seconds()
            }
          }, interval)
        }
      })
  },
  mounted: function () {
    setTimeout(() => {
      window.$('.hero-slider').owlCarousel({
        autoPlay: false,
        navigation: true,
        navigationText: [
          '<img src="../../static/distribution-musical/img/slider-left-thin-arrow.png">',
          '<img src="../../static/distribution-musical/img/slider-right-thin-arrow.png">'
        ],
        slideSpeed: 300,
        paginationSpeed: 400,
        singleItem: true,
        items: 1,
        autoHeight: true,
        addClassActive: true
      })
    }, 100)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ProWeekend.vue